import { Autocomplete, TextField } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  labels: string[]
  onChange: Function
}

export function SearchLabels ({ labels, onChange }: Props) {
  const { t } = useTranslation()
  return (
    <>
      <Autocomplete
        fullWidth
        multiple
        options={labels}
        handleHomeEndKeys
        getOptionLabel={(option) => option}
        onChange={(event: any, selectValues: string[]) => {
          onChange(selectValues)
        }}
        renderInput={(params) => (
          <TextField
            placeholder={`${t('search.titleLabel')}`}
            autoComplete="off"
            {...params}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {params.InputProps.endAdornment}
                </>
              )
            }}
          />
        )}
      />
    </>
  )
}
